import { TApplicationState } from 'shared/types/redux';

export const selectActiveStep = (state: TApplicationState) => {
  return state.joinOtaIndividual.stepsConfiguration.activeStep;
};
